import vuexStore from '@/vuex-store';
import { authGetterType } from '@/vuex-store/auth/getters';
import OrderPolicy from './helpers/OrderPolicy';
import requestHelper from './helpers/requestHelper';
import setClientInstanceInterceptors from './helpers/interceptors';
import { userGetterType } from './vuex-store/user/getters';
import { userActionType } from './vuex-store/user/actions';
const isAuthenticated = () => vuexStore.getters[authGetterType.isAuthenticated];
const isInitialized = () => !vuexStore.getters[userGetterType.isInitialized];
const initUser = async () => vuexStore.dispatch(userActionType.initUser);
const clearUser = async () => vuexStore.dispatch(userActionType.clearUser);
const setRequestHelper = () => {
    requestHelper.setStartSpinner(() => vuexStore.dispatch('app/startFetching'));
    requestHelper.setEndSpinner(() => vuexStore.dispatch('app/endFetching'));
};
// TODO 모바일 코드
// const getOrderList = async () => store.dispatch('order/getOrderList');
// const getFulfillmentTable = async () => store.dispatch('fulfillment/getFulfillmentTable');
// const startAppTick = async () => store.dispatch('app/startAppTick');
const initOrderPolicy = () => {
    OrderPolicy.initialize(vuexStore);
};
const initApp = async ({ vueCreated = true,
// isMobile = false,
 }) => {
    try {
        // 최초 실행시만 실행
        if (!vueCreated) {
            setClientInstanceInterceptors();
            setRequestHelper();
        }
        if (isAuthenticated()) {
            if (isInitialized()) {
                await initUser();
            }
            initOrderPolicy();
            // TODO 모바일 코드
            // if (isMobile) {
            // getOrderList();
            // getFulfillmentTable();
            // startAppTick();
            // }
        }
    }
    catch (error) {
        console.log('initApp', error);
        await clearUser();
    }
};
export default initApp;
